import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import uiReducer from './uiSlice';
import sitesReducer from './sitesSlice';
import bonusesReducer from './bonusesSlice';
import usersReducer from './usersSlice';
import promoCodesReducer from './promoCodesSlice';
import auditLogsReducer from './auditLogsSlice';
import siteSocialsReducer from './siteSocialsSlice';
import referralReducer from './referralSlice';
import paymentProvidersReducer from './paymentProvidersSlice';
import paymentSettingsReducer from './paymentSettingsSlice';
import transactionsReducer from './transactionsSlice';
import onlineUsersReducer from './onlineUsersSlice';
import toastReducer from './toastSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    ui: uiReducer,
    sites: sitesReducer,
    bonuses: bonusesReducer,
    users: usersReducer,
    promoCodes: promoCodesReducer,
    auditLogs: auditLogsReducer,
    siteSocials: siteSocialsReducer,
    referral: referralReducer,
    paymentProviders: paymentProvidersReducer,
    paymentSettings: paymentSettingsReducer,
    transactions: transactionsReducer,
    onlineUsers: onlineUsersReducer,
    toast: toastReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: { auth: AuthState }
export type AppDispatch = typeof store.dispatch;
